import { useState } from "react";

import { DownloadOutlined } from "@ant-design/icons";
import { Trans } from "@lingui/macro";
import { Button, Dropdown, MenuProps } from "antd";

import ExportModal from "components/export/modal";

import { useApplicationContext } from "contexts/app";

const Exports = ({
  optionsUrl,
  loading,
  formats,
  callback,
  ordering,
}: {
  optionsUrl: string;
  loading: boolean;
  formats: { name: string; value: string }[];
  callback: (fn: any) => void;
  ordering: string[];
}) => {
  const [exportData, setExportData] = useState<{ state?: string } | null>(null);
  const [modalProps, setModalProps] = useState<any>();
  const [isExportingFile, setIsExportingFile] = useState(false);
  const [format, setFormat] = useState("");
  const [controller, setController] = useState(new AbortController());

  const { configuration, language, httpClient } = useApplicationContext();

  const account = configuration?.account;
  const signal = controller?.signal;

  const handleError = (response: any) => {
    if (response === false) {
      setExportData({ state: "failed" });
      setIsExportingFile(false);
    }
  };

  const handleExportPolling = async (response: any, setExportData: Function) => {
    const res = response?.url && (await httpClient.get(response.url, { config: { signal } }));

    if (res === false) {
      setExportData({ state: "failed" });
    }

    setExportData(res);

    if (res?.state === "completed") {
      return res;
    }

    if (!signal?.aborted && (res?.state === "pending" || res?.state === "in_progress")) {
      await new Promise((resolve) => setTimeout(resolve, 5000));
      await handleExportPolling(res, setExportData);
    }
  };

  const handleExport = async (columns: string[], format: string) => {
    setFormat(format);

    setModalProps({ users: { isModalVisible: true } });

    if (exportData) {
      setExportData(null);
    }

    // This "setIsExportingFile" state tells about the progress of the api in case the user decides to cancels it in future
    // And it also helps to unsubscribe or remove the signal controller from the api request
    // Just in case the api is called again by the user
    setIsExportingFile(true);

    const response = await httpClient.post(optionsUrl, {
      data: { account: account?.url, params: { columns, ordering: ordering } },

      config: { signal },
    });

    handleError(response);
    if (response) {
      const exportResponse = await httpClient.post(`${response?.url}export/`, {
        data: { format: format, language: language, params: { columns, ordering: ordering } },
        config: {
          signal,
        },
      });
      exportResponse && (await handleExportPolling(exportResponse, setExportData));
      handleError(exportResponse);
    }
  };

  const items: MenuProps["items"] = formats?.map((format) => {
    return {
      key: format.value,
      label: (
        <div onClick={() => callback((columns: string[]) => handleExport(columns, format.value))}>{format.name}</div>
      ),
    };
  });

  return (
    <>
      <ExportModal
        {...{
          isExportingFile,
          setIsExportingFile,
          modalProps,
          setModalProps,
          view: "users",
          controller,
          setController,
          exportData,
          setExportData,
          handleExport,
          format,
        }}
      />
      <Dropdown menu={items ? { items } : { items: [] }} placement="bottom">
        <Button type="default" disabled={loading} icon={<DownloadOutlined />}>
          <>
            <Trans>Export</Trans>
          </>
        </Button>
      </Dropdown>
    </>
  );
};

export default Exports;
